import moment from "moment";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import localeIntl from "./intl/data.json";
import * as authAct from "./lib/store/auth/_authActions";
import * as utilsAct from "./lib/store/utils/_utilsActions";
import { hp, cf } from "./lib/utils";
const AppContainer = React.lazy(() => import("./screens/AppContainer"));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pathname: "",
    };
  }

  componentDidMount() {
    const {
      auth: { user, authenticated },
    } = this.props;
    if (authenticated) {
      if (hp.hasP("ACCESS_PUSH", user.role)) {
        this.getAccountBalance();
      } else {
        window.location.assign(cf.REACT_APP_ACCOUNT_APP_URL);
      }
    } else {
      this.props.signOut();
    }
  }

  componentDidUpdate() {
    this.getAccountBalance();
  }

  getAccountBalance() {
    const token = hp.getCookie("user_token");
    const {
      auth: {
        user: { user_id },
      },
      history: {
        location: { pathname },
      },
    } = this.props;
    if (token && pathname !== this.state.pathname) {
      this.setState({ pathname: pathname }, () => {
        this.props.getAccountBalance(user_id, token);
      });
    }
  }

  render() {
    const {
      auth: { authenticated, user },
      utils: { lang },
    } = this.props;
    return (
      <IntlProvider
        locale={lang}
        defaultLocale={"en"}
        messages={localeIntl[lang]}
      >
        <React.Suspense fallback={<div />}>
          {authenticated && hp.hasP("ACCESS_PUSH", user.role) && (
            <AppContainer />
          )}
        </React.Suspense>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  utils: state.utils,
});

const mapDispatchToProps = (dispatch) => ({
  getAccountBalance: (user_id, token) => {
    dispatch(authAct.getAccountBalance(user_id, token));
  },
  signOut: () => {
    dispatch(authAct.signOut());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
